export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9742.91c49f47.jpg";